import { SanityClient, ObservableSanityClient, defineCreateClientExports, envMiddleware } from './_chunks/browserMiddleware-FL0Mlm8l.js';
export { BasePatch, BaseTransaction, ClientError, ObservablePatch, ObservableTransaction, Patch, ServerError, Transaction, vercelStegaCleanAll } from './_chunks/browserMiddleware-FL0Mlm8l.js';
export { adapter as unstable__adapter, environment as unstable__environment } from 'get-it';
export { encodeIntoResult, stegaEncodeSourceMap } from './_chunks/stegaEncodeSourceMap-LDHMEOVo.js';

class SanityStegaClient extends SanityClient {
}
class ObservableSanityStegaClient extends ObservableSanityClient {
}

const exp = defineCreateClientExports(envMiddleware, SanityClient);
const requester = exp.requester;
const createClient = exp.createClient;

export { ObservableSanityClient, ObservableSanityStegaClient, SanityClient, SanityStegaClient, createClient, requester };
//# sourceMappingURL=stega.browser.js.map
